import getCookie from '../cookie/get-cookie'

export default () => getCookie('language') === 'en' ? 'en-gb' : getCookie('language') === 'cn' ? 'zh-cn' : (getCookie('language') || 'en')
